import React from 'react';

type RSSLinkProps = {pathSegment: string};

/**
 * Make sure this matches the getRSSLinkTag function in host/meta.ts. Ideally, we should use the component to
 * create the corresponding meta string, but there are some tslint errors when trying to import components
 * from app to host still.
 */
export const RSSLink = ({pathSegment}: RSSLinkProps) => (
  <link
    rel="alternate"
    type="application/rss+xml"
    href={`https://wandb.ai/${pathSegment}/rss.xml`}
  />
);
